let lockCount = 0;
let previousStyles = null;

export const lockBodyScroll = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return () => {};
  }

  const { body, documentElement } = document;

  if (lockCount === 0) {
    const scrollbarWidth = Math.max(
      0,
      window.innerWidth - documentElement.clientWidth
    );

    previousStyles = {
      bodyOverflow: body.style.overflow,
      bodyPaddingRight: body.style.paddingRight,
      htmlOverflow: documentElement.style.overflow,
    };

    documentElement.style.overflow = "hidden";
    body.style.overflow = "hidden";

    if (scrollbarWidth > 0) {
      const currentPadding =
        parseFloat(window.getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
    }
  }

  lockCount += 1;

  return () => {
    lockCount = Math.max(0, lockCount - 1);

    if (lockCount === 0 && previousStyles) {
      documentElement.style.overflow = previousStyles.htmlOverflow;
      body.style.overflow = previousStyles.bodyOverflow;
      body.style.paddingRight = previousStyles.bodyPaddingRight;
      previousStyles = null;
    }
  };
};
